import React, { Component } from "react";
import moment from "moment";

import Modal from "react-bootstrap/Modal";

import { borrowerProfilePatch } from "../../../api/borrower";

import UBXFormDate from "../../ubx/form/date";
import UBXFormSelect from "../../ubx/form/select";
import UBXButton from "../../ubx/button";
import UBXNotice from "../../ubx/notice";

import { ProfileForm } from "../../../config/profile";

import ProvincesOptions from "./../../../const/provinces";

import User from "../../user/user";

import "./../../../assets/css/components/profile/modal/update.css";

export default class ProfileUpdateModal extends Component {
    _mounted = false;

    constructor(props) {
        super(props);

        this.state = {
            error: false,
            busy: false,
            form: {},
            formReady: false,
        };
    }

    async submit(data) {
        const payload = {};
        for (let fieldName in data) {
            if (ProfileForm[fieldName]) {
                const {
                    dbField = false,
                    isAdditionalInfo = false,
                    additionalInfoField = false,
                } = ProfileForm[fieldName];

                if (dbField) {
                    const value = data[fieldName];
                    if (!isAdditionalInfo) {
                        payload[dbField] = value;
                    } else {
                        if (!payload["borrower_additional_info"]) {
                            payload["borrower_additional_info"] = {};
                        }
                        if (additionalInfoField) {
                            payload["borrower_additional_info"][additionalInfoField] = value;
                        } else {
                            payload["borrower_additional_info"][dbField] = value;
                        }
                    }
                }
            }
        }

        let result = false;
        try {
            const updateDataResponse = await borrowerProfilePatch(payload);
            const { data = false } = updateDataResponse;

            if (data) {
                // update profile
                User.saveProfile(data);

                // check if values exists in updated profile
                result = Object.keys(payload).every((field) => Object.keys(data).includes(field));
            } else {
                throw updateDataResponse;
            }
        } catch (e) {
            await this.handleError(e);
        }

        return result;
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    componentDidMount() {
        this._mounted = true;
    }

    async handleError(e) {
        const {
            response: {
                data: {
                    status,
                    data: { message },
                },
            },
        } = e;

        let error = false;
        switch (status) {
            case "FAILED":
                error = "It seems that you are offline. Please check your internet.";
                break;
            case 400:
            case 401:
                error = message;
                break;
            default:
                error = "Something went wrong.";
                break;
        }

        await this.setState({ error });
    }

    onOpen() {
        const { onOpen = false } = this.props;

        if (onOpen) {
            onOpen();
        }
    }

    onClose() {
        const { onClose = false } = this.props;

        if (onClose) {
            onClose();
        }
    }

    onError(name, label) {
        // console.log("onError", { name, label });
    }

    onSuccess() {
        const { onSuccess = false } = this.props;

        if (onSuccess) {
            onSuccess();
            this.onClose();
        }
    }

    async onChange(name, value) {
        const { form = {} } = this.state;

        const { format = false } = ProfileForm[name];

        switch (format) {
            case "date": {
                const dateValue = moment(value);
                form[name] = dateValue.isValid() ? dateValue.format("YYYY-MM-DD") : "";
                break;
            }
            default: {
                form[name] = value;
                break;
            }
        }

        await this.setState({ form });

        this.checkForm();
    }

    async checkForm() {
        const { fields = [] } = this.props;
        const { form } = this.state;

        let formReady = true;
        fields.forEach((field) => {
            if (form[field] === "" || form[field] === undefined || form[field] === null) {
                formReady = false;
            }
        });

        this.setState({ formReady });
    }

    async onSubmit(e) {
        e.preventDefault();

        await this.setState({ busy: true });

        const { form, formReady } = this.state;

        let isSubmitted = false;
        if (formReady) {
            isSubmitted = await this.submit(form);
        }

        await this.setState({ busy: false });

        if (isSubmitted) {
            this.onSuccess();
        }

        return false;
    }

    renderHeader() {
        return (
            <Modal.Header closeButton closeLabel="Close Profile Update Modal">
                <div className="profile-update-header">Please complete these information</div>
            </Modal.Header>
        );
    }

    renderBody() {
        const { fields = [] } = this.props;

        const fieldsToUpdate = [];
        const renderedFields = [];
        if (fields.includes("representative-birthdate")) {
            const otherProps = { ...ProfileForm["representative-birthdate"] };

            delete otherProps["dbField"];
            delete otherProps["readonly"];

            renderedFields.push(
                <div key="representative-birthdate" className="profile-update-field">
                    <UBXFormDate
                        type="birthday"
                        name="representative-birthdate"
                        label="Birthday"
                        onChange={(name, value) => this.onChange(name, value)}
                        onError={(name, label) => this.onError(name, label)}
                        {...otherProps}
                    />
                </div>,
            );

            fieldsToUpdate.push("birthday");
        }
        if (fields.includes("business-province")) {
            const otherProps = { ...ProfileForm["business-province"] };

            delete otherProps["dbField"];

            renderedFields.push(
                <div key="business-province" className="profile-update-field">
                    <UBXFormSelect
                        type="dropdown"
                        name="business-province"
                        label="Business Location"
                        caption="Province where your business is registered"
                        options={ProvincesOptions}
                        sort={true}
                        onChange={(name, value) => this.onChange(name, value)}
                        {...otherProps}
                    />
                </div>,
            );

            fieldsToUpdate.push("business location");
        }

        if (fieldsToUpdate.length > 1) {
            const lastFieldToUpdate = fieldsToUpdate.pop();
            fieldsToUpdate.push(`and ${lastFieldToUpdate}`);
        }

        return (
            <Modal.Body>
                <div className="profile-update-content">
                    <p>To continue with your application, please provide your {fieldsToUpdate.join(", ")}.</p>
                    {renderedFields}
                    <UBXNotice icon={true} show={true} type="info">
                        We'll be using these information to see if you are eligible to apply for this loan.
                    </UBXNotice>
                </div>
            </Modal.Body>
        );
    }

    renderFooter() {
        const { busy, formReady, error } = this.state;

        const buttons = [];
        buttons.push(
            <UBXButton
                key={"submit-button"}
                type="primary"
                block={true}
                disabled={busy || !formReady}
                onClick={(e) => this.onSubmit(e)}
            >
                Continue
            </UBXButton>,
        );

        let errorMessage = "";
        if (error) {
            errorMessage = <span className="error">{error}</span>;
        }

        return (
            <Modal.Footer>
                {buttons}
                {errorMessage}
            </Modal.Footer>
        );
    }

    render() {
        const { id, show } = this.props;

        return (
            <Modal
                id={id}
                className="profile-update"
                show={show}
                backdrop="static"
                centered
                onShow={() => this.onOpen()}
                onHide={() => this.onClose()}
            >
                {this.renderHeader()}
                {this.renderBody()}
                {this.renderFooter()}
            </Modal>
        );
    }
}
